import React from 'react';
import PropTypes from 'prop-types';
import {Map} from 'immutable';
import SimpleModal from 'generic/SimpleModal/SimpleModal.react';
import appStore from 'client/AppStore';
import {mandarkEndpoint} from '@albert-io/json-api-framework/request/builder/legacy';
import LoadingIndicator from 'generic/LoadingIndicator.react';
import SimpleDropdown from 'generic/SimpleDropdown/SimpleDropdown.react';
import Button from 'sg/Button/Button.react';
import {getStoreByName} from 'client/framework';
import './assign-practice-exam-modal.scss';

export default class AssignPracticeExamModal extends React.Component {
  static propTypes = {
    onModalClose: PropTypes.func
  };

  dropdownStoreName = 'AssignPracticeExamModalSubjectDropdown';

  getClassroomQuery() {
    return mandarkEndpoint(['classrooms_v1', appStore.routerProps.params.classId])
      .include('subjects_v2')
      .customQuery({
        with_meta: 'subject_v2'
      })
      .filter({
        included: {
          subjects_v2: {
            'meta.count_of_practice_exams': {
              greater_than: 0
            }
          }
        }
      });
  }

  getDropdownOptions() {
    return this.getClassroomQuery()
      .getResource()
      .getSubjects()
      .map((subject) =>
        Map({
          name: subject.getName(),
          id: subject.getId(),
          slug: subject.getUrlSlug()
        })
      );
  }

  getPracticeExamsLink() {
    const dropdownStore = getStoreByName(this.dropdownStoreName);
    const isReady = dropdownStore && !dropdownStore.getSelectedItem().isEmpty();
    if (!isReady) {
      return '';
    }
    const selectedSubject = dropdownStore.getSelectedItem();
    return `/${selectedSubject.get('slug')}/assessments`;
  }

  render() {
    const content = this.getClassroomQuery().isResourcePopulated() ? (
      <div>
        <SimpleDropdown
          fullWidth
          destroyStoreOnUnmount
          label='Select Subject'
          storeName={this.dropdownStoreName}
          options={this.getDropdownOptions()}
        />
        <Button
          color='green'
          text='Go to assessments'
          className='assign-practice-exam-modal__btn'
          to={this.getPracticeExamsLink()}
        />
      </div>
    ) : (
      <LoadingIndicator />
    );
    const classroom = this.getClassroomQuery().getResource();
    return (
      <SimpleModal
        title='Assign Assessment'
        onModalClose={this.props.onModalClose}
        className='assign-practice-exam-modal'
      >
        {content}
      </SimpleModal>
    );
  }
}
